import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { postBulkTransactionsAPI } from 'api/bulk-transactions'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  BulkTransactionsTxFormTypes,
  BulkTransactionsTxFormSubmitValuesTypes,
  BulkTransactionsTxFormSubmitActionsTypes,
} from 'types/bulkTransactionsTXTypes'

const BulkTransactionsTXINITVAL: BulkTransactionsTxFormTypes = {
  batchId: 0,
  startCardNumber: '',
  endCardNumber: '',
  transactionTypeId: 0,
  fromTraderId: 0,
  deviceCode: 0,
  toTraderIds: [],
  statusId: 0,
  transactionDate: '',
  purchaseValue: 0,
  voucherValue: 0,
  loyaltyValue: 0,
  creditValue: 0,
  paymentMethodId: 0,
  manualEntryTypeId: 0,
  glCode: '',
  addToCode: '',
  consolidationCode: '',
  comments: '',
  custom1: '',
  custom2: '',
  custom3: '',
  flTest: 0,
  flManualOverride: 0,
  flOnline: 0,
}

export const useBulkTransactionsTx = (
  onCloseModal: () => void
): {
  isLoading: boolean
  initialValues: BulkTransactionsTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleMerchantSet: (merchant: MerchantLookupTypes[]) => void
  handleSubmitBulkTransactionsTx: (
    values: BulkTransactionsTxFormSubmitValuesTypes,
    actions: BulkTransactionsTxFormSubmitActionsTypes
  ) => void
  handleClearBulkTransactionsTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<MerchantLookupTypes[]>([])
  const [initialValues, initialValuesSet] = useState<BulkTransactionsTxFormTypes>({
    ...BulkTransactionsTXINITVAL,
    // cashier: authTokenUsername,
    // externalTransactionId: formatter.externalIdentification(),
  })
  const normalizeValues = (values: BulkTransactionsTxFormSubmitValuesTypes): BulkTransactionsTxFormSubmitValuesTypes => {
  return {
    ...values,
    deviceCode: typeof values.deviceCode === 'string' ? Number(values.deviceCode) : values.deviceCode,
  }
}

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleMerchantSet = useCallback(
    async (merchant: MerchantLookupTypes[]) => {
      try {
        purchaseTxMerchantSet(merchant)
        toast.success('Merchant Selected')
      } catch (error) {
        toast.error('Something went wrong.')
      }
    },
    [purchaseTxMerchantSet]
  )

  const handleSubmitBulkTransactionsTx = useCallback(
    async (
      values: BulkTransactionsTxFormSubmitValuesTypes,
      actions: BulkTransactionsTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        const normalizedValues = normalizeValues(values);
        await postBulkTransactionsAPI(normalizedValues)
        toast.success('Bulk transaction successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearBulkTransactionsTx = useCallback(() => {
    initialValuesSet({ ...BulkTransactionsTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleMerchantSet,
    handleSubmitBulkTransactionsTx,
    handleClearBulkTransactionsTx,
  }
}
